/** Le plus grand cote de l'image fixe, en pixels : assez pour une grande vignette sur un ecran dense. */
const COTE_MAX = 640;

/**
 * LA PREMIERE IMAGE D'UNE IMAGE ANIMEE (un GIF), figee en PNG : la vignette la
 * montre au repos, et ne joue l'animation qu'au survol ou dans la visionneuse
 * (recette du 02/11 : une grille qui bouge en permanence derange). Dessinee
 * juste apres son decodage, une image animee donne sa premiere image.
 */
export async function imageFixe(url: string): Promise<Blob> {
  const image = new Image();
  image.src = url;
  await image.decode();
  const echelle = Math.min(1, COTE_MAX / Math.max(image.naturalWidth, image.naturalHeight, 1));
  const toile = document.createElement('canvas');
  toile.width = Math.max(1, Math.round(image.naturalWidth * echelle));
  toile.height = Math.max(1, Math.round(image.naturalHeight * echelle));
  const contexte = toile.getContext('2d');
  if (contexte === null) throw new Error('Image fixe impossible : pas de contexte 2D.');
  contexte.drawImage(image, 0, 0, toile.width, toile.height);
  return await new Promise<Blob>((rendre, refuser) => {
    toile.toBlob((blob) => { if (blob === null) refuser(new Error('Image fixe impossible.')); else rendre(blob); }, 'image/png');
  });
}
